module.exports = __webpack_public_path__ + "img/present_pics.bd272083.jpg";